import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { Form, Header, Label, Segment } from 'semantic-ui-react';
import { uniqueKey } from '../../../../global/common/keys';
import { listList } from '../../../../global/lists/lists';
import { CreateSportsSeasonContext } from '../CreateSeason';
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper';
import { useCreateSportsSeason } from 'projectSpecific/sports/useHelpers/useCreateSeasonal';

const CreateCrossoverSections = () => {

  // createSportsContext
  const createSportsSeasonContext = useContext(CreateSportsSeasonContext);
  const { createSportsSeason_state, createSportsSeason_handlers } = createSportsSeasonContext ?? {}
  // const { sportsSeason_selected } = createSportsSeason_state ?? {}
  const { getCreateSportsSeason } = useCreateSportsSeason()
  const { sportsSeason_selected, selectedItems } = getCreateSportsSeason()
  const { seasonals } = sportsSeason_selected ?? {}
  const { levelTeams, sectionCrossovers } = seasonals ?? {}

  const [availableLevelTeams, setAvailableLevelTeams] = useState()
  const [availableOptions, setAvailableOptions] = useState()

  useEffect(() => {
    // if levelTeams chages...
    const _lts = {}
    if (levelTeams) {
      const opts = []
      _.forEach(levelTeams, (level, levelKey) => {
        if (!_.isEmpty(level)) {
          _lts[levelKey] = {}
          _.forEach(level, (section, sectionKey) => {
            if (!_.isEmpty(section)) {
              _lts[levelKey][sectionKey] = section
              const _key = levelKey + '_' + sectionKey
              opts.push({
                text: _key,
                key: _key,
                value: _key
              })
            }
          })
        }
      })
      setAvailableLevelTeams(_lts)
      setAvailableOptions(opts)
    }
    // eslint-disable-levelTeams-line react-hooks/exhaustive-deps 
  }, [levelTeams]);

  const handleSectionSelect = (e, d) => {
    const { id, value } = d
    const _sectionCrossovers = { ...sectionCrossovers }
    _sectionCrossovers[id] = value
    createSportsSeason_handlers.handleAmmend_sectionCrossovers(_sectionCrossovers)
  }

  /**
   * 
   * @param {string} lsKey 
   * @param {string} sectionKey 
   * @param {object} teams_section 
   * @returns a dropdown with options
   */
  const ddSections = (lsKey, sectionKey, teams_section) => {

    const ddOptions = listList(availableOptions, true)

    const _key = lsKey + '_' + sectionKey
    const xx = sectionCrossovers ? sectionCrossovers[lsKey] : null

    return <Form.Dropdown
      className='swiper-no-swiping'
      key={uniqueKey('cs', 'dd', lsKey, sectionKey)}
      id={lsKey + '_' + sectionKey}
      value={xx}
      options={ddOptions}
      fluid
      search
      selection
      onChange={handleSectionSelect}
    />
  }

  /** Returns a Checker for each `section` */
  const sectionSegs = (lsKey, sectionKey, teams_section) => {
    const segs = []
    segs.push(ddSections(lsKey, sectionKey, teams_section))
    return segs
  }

  /** Returns a `Segment.Group` for each `level` */
  const levelSegs = () => {
    const segs = []
    _.forEach(availableLevelTeams, (levelSection, levelKey) => {
      segs.push(<Segment className={'level-container'}>{levelKey}</Segment>)
      _.forEach(_.sortBy(_.keys(levelSection)), (sectionKey) => {
        const section = levelSection[sectionKey];
        const lsKey = levelKey + '_' + sectionKey
        segs.push(
          <Segment.Group key={uniqueKey('crsec', 'sg', lsKey, sectionKey)} className={'section-container'}>
            <Header>
              <Label color={'blue'}> {_.startCase(sectionKey)}</Label>
            </Header>
            <Segment>{sectionSegs(lsKey, sectionKey, section)}</Segment>
          </Segment.Group>
        )
      })
    })
    return <div className={'sections-container'}>{segs}</div>
  }

  const wrapper = () => <Wrapper
    header={'Section Crossovers'}
    content={levelSegs()}
    wrapperType={wrapperTypes.paddedHeader}
  />

  return availableLevelTeams && availableOptions ? wrapper() : <div className='hwcc'>No Crossover Matches</div>

}

export default CreateCrossoverSections